function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicatedocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "duplicate (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10652"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46875",
    d: "m72.218 14.255 13.027 13.027a7.772 7.772 0 0 1 2.255 5.511v61.378a7.805 7.805 0 0 1-7.766 7.766H23.366a7.805 7.805 0 0 1-7.766-7.766V19.766A7.805 7.805 0 0 1 23.366 12h43.34a7.772 7.772 0 0 1 5.511 2.255z",
    transform: "translate(23.225 18.063)",
    style: {
      fill: "#e4e7e7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10653"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46876",
    d: "M87.75 32.793v61.378a7.805 7.805 0 0 1-7.766 7.766H23.366a7.805 7.805 0 0 1-7.766-7.766V19.766A7.805 7.805 0 0 1 23.366 12h43.34a7.714 7.714 0 0 1 3.257.752 11.764 11.764 0 0 1 2.255 1.5l13.027 13.03a5.916 5.916 0 0 1 1.5 2.255 5.511 5.511 0 0 1 1.005 3.256z",
    transform: "translate(23.225 18.063)",
    style: {
      fill: "#eaeaea"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10654"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46877",
    d: "M54.335 29.235H41.308a3.957 3.957 0 0 1-4.008-4.008V12.2a11.764 11.764 0 0 1 2.255 1.5l13.027 13.03c.752 1 1.253 1.754 1.754 2.505z",
    transform: "translate(55.888 18.364)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10655"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46878",
    d: "M75.607 21.044v9.019H41.286a7.805 7.805 0 0 0-7.766 7.766v52.359H11.474a7.805 7.805 0 0 1-7.766-7.766V7.766A7.5 7.5 0 0 1 11.474 0h43.09a7.772 7.772 0 0 1 5.511 2.255L73.1 15.282a7.255 7.255 0 0 1 2.505 5.762z",
    transform: "translate(5.305)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10656"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46879",
    d: "M75.607 21.044v9.019H41.286a7.805 7.805 0 0 0-7.766 7.766v52.359H11.474a7.805 7.805 0 0 1-7.766-7.766V7.766A7.5 7.5 0 0 1 11.474 0h43.09a7.714 7.714 0 0 1 3.256.752 11.764 11.764 0 0 1 2.255 1.5L73.1 15.282a5.916 5.916 0 0 1 1.5 2.255 6.262 6.262 0 0 1 1 3.507z",
    transform: "translate(5.305)",
    style: {
      fill: "#d8d8d8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10657"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46880",
    d: "M42.335 17.335H29.308a3.957 3.957 0 0 1-4.008-4.008V.3a11.764 11.764 0 0 1 2.255 1.5l13.027 13.03a4.236 4.236 0 0 1 1.753 2.505z",
    transform: "translate(37.825 .452)",
    style: {
      fill: "#e4e7e7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10668"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10658"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46881",
    d: "M45.619 45.308H38.6a2 2 0 0 1 0-4.008h7.015a2.155 2.155 0 0 1 2 2c-.243 1.006-.994 2.008-1.996 2.008z",
    transform: "translate(54.834 62.166)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10667"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10659"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46882",
    d: "M50.737 27.308H35.2a2.155 2.155 0 0 1-2-2 2.155 2.155 0 0 1 2-2h15.537a2.155 2.155 0 0 1 2 2c-.247.998-.998 2-2 2z",
    transform: "translate(49.716 35.072)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10660"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46883",
    d: "M49.814 27.308H21a2.155 2.155 0 0 1-2-2 2.155 2.155 0 0 1 2-2h28.81a2.155 2.155 0 0 1 2 2 1.976 1.976 0 0 1-1.996 2z",
    transform: "translate(28.342 35.072)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10661"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46884",
    d: "M72.111 31.808H21a2 2 0 0 1 0-4.008h51.111a2.155 2.155 0 0 1 2 2c-.247 1.006-.998 2.008-2 2.008z",
    transform: "translate(28.342 41.845)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10662"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46885",
    d: "M49.984 36.308H35.7a2 2 0 0 1 0-4.008h14.28a2.155 2.155 0 0 1 2 2c-.242 1.006-.994 2.008-1.996 2.008z",
    transform: "translate(50.469 48.619)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10663"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46886",
    d: "M50.566 36.308H21a2 2 0 0 1 0-4.008h29.566a2 2 0 0 1 0 4.008z",
    transform: "translate(28.342 48.619)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10664"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46887",
    d: "M55.854 40.808H31.8a2 2 0 0 1 0-4.008h24.05a2.155 2.155 0 0 1 2 2c-.242 1.006-.994 2.008-1.996 2.008z",
    transform: "translate(44.598 55.392)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10665"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46888",
    d: "M41.046 40.808H21a2 2 0 0 1 0-4.008h20.046a2 2 0 0 1 0 4.008z",
    transform: "translate(28.342 55.392)",
    style: {
      fill: "#ccd0d2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10666"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46889",
    d: "M57.831 45.308H21a2 2 0 0 1 0-4.008h36.831a2 2 0 0 1 0 4.008z",
    transform: "translate(28.342 62.166)",
    style: {
      fill: "#ccd0d2"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicatedocument);
export default __webpack_public_path__ + "static/media/duplicatedocument.28a17e259b7044b0709d2c10a3842e37.svg";
export { ForwardRef as ReactComponent };